import React from 'react'
import MainLayout from '../components/MainLayout'

const PaymentInfoMst = () => {
  return (
     <MainLayout pageName={"2"}>
  <div>PaymentInfoMst</div>
     </MainLayout>
  
  )
}

export default PaymentInfoMst